/**
 * Categories of commands used to organize commands on UI
 */
export enum DeviceCommandCategoryEnum {
  Player = 'Player',
  Utilities = 'Utilities',
  Miscellaneous = 'Miscellaneous',
}
